"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputIcon = void 0;

var React = require("react");

var styled_components_1 = require("styled-components");

var StyledIcon = styled_components_1.default.div(function (_a) {
  var theme = _a.theme,
      $isRight = _a.$isRight,
      $floatingLabel = _a.$floatingLabel,
      disabled = _a.disabled,
      $iconColor = _a.$iconColor,
      $isFloating = _a.$isFloating;
  return styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    position: absolute;\n    left: 8px;\n    top: 50%;\n    transform: translateY(-50%);\n    transition: all 250ms;\n    color: ", ";\n\n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    position: absolute;\n    left: 8px;\n    top: 50%;\n    transform: translateY(-50%);\n    transition: all 250ms;\n    color: ", ";\n\n    ", "\n\n    ", "\n\n    ", "\n  "])), theme.colors[$iconColor], $isRight && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        left: unset;\n        right: 8px;\n      "], ["\n        left: unset;\n        right: 8px;\n      "]))), $floatingLabel && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        color: ", ";\n\n        ", "\n      "], ["\n        color: ", ";\n\n        ", "\n      "])), theme.colors.greyDark, $isFloating && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            ", "\n            color: ", ";\n          "], ["\n            ", "\n            color: ", ";\n          "])), !$isRight && "\n              top: 6px;\n              transform: translateY(0);\n            ", theme.colors[$iconColor])), disabled && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        color: ", ";\n      "], ["\n        color: ", ";\n      "])), theme.colors.disabledColor));
});

function InputIcon(_a) {
  var icon = _a.icon,
      color = _a.color,
      onClick = _a.onClick,
      fontSize = _a.fontSize,
      labelSize = _a.labelSize,
      $isRight = _a.isRight,
      $isFloating = _a.isFloating,
      $floatingLabel = _a.floatingLabel;
  return React.createElement(StyledIcon, {
    as: icon,
    "$isRight": $isRight,
    size: $isFloating && $floatingLabel && !$isRight ? labelSize : fontSize,
    "$floatingLabel": $floatingLabel,
    "$isFloating": $isFloating,
    "$iconColor": color || 'primary',
    onClick: onClick
  });
}

exports.InputIcon = InputIcon;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;